/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_SettingsInputs */

const th_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียดทีม`)
};

const en_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team details`)
};

const ja_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームの詳細`)
};

const zh_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队信息`)
};

const es_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles del equipo`)
};

const pt_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes do time`)
};

const id_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detail tim`)
};

const fr_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de l’équipe`)
};

const tl_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalye ng team`)
};

const vi_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết đội`)
};

const ko_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀 정보`)
};

const de_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team-Details`)
};

const ru_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные команды`)
};

const tr_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım bilgileri`)
};

const it_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli della squadra`)
};

const pl_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły drużyny`)
};

const uk_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дані команди`)
};

const hi_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम का विवरण`)
};

const ar_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تفاصيل الفريق`)
};

const ms_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiran pasukan`)
};

const bn_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দলের বিবরণ`)
};

const zh_tw2_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊資訊`)
};

const zh_hk2_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊資訊`)
};

const ur_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم کی تفصیل`)
};

const fa_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جزئیات تیم`)
};

const sw_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelezo ya timu`)
};

const nl_team_settings = /** @type {(inputs: Team_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens van het team`)
};

/**
* | output |
* | --- |
* | "Team details" |
*
* @param {Team_SettingsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const team_settings = /** @type {((inputs?: Team_SettingsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_SettingsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_team_settings(inputs)
	if (locale === "ja") return ja_team_settings(inputs)
	if (locale === "zh") return zh_team_settings(inputs)
	if (locale === "es") return es_team_settings(inputs)
	if (locale === "pt") return pt_team_settings(inputs)
	if (locale === "id") return id_team_settings(inputs)
	if (locale === "fr") return fr_team_settings(inputs)
	if (locale === "tl") return tl_team_settings(inputs)
	if (locale === "vi") return vi_team_settings(inputs)
	if (locale === "ko") return ko_team_settings(inputs)
	if (locale === "de") return de_team_settings(inputs)
	if (locale === "ru") return ru_team_settings(inputs)
	if (locale === "tr") return tr_team_settings(inputs)
	if (locale === "it") return it_team_settings(inputs)
	if (locale === "pl") return pl_team_settings(inputs)
	if (locale === "uk") return uk_team_settings(inputs)
	if (locale === "hi") return hi_team_settings(inputs)
	if (locale === "ar") return ar_team_settings(inputs)
	if (locale === "ms") return ms_team_settings(inputs)
	if (locale === "bn") return bn_team_settings(inputs)
	if (locale === "zh-TW") return zh_tw2_team_settings(inputs)
	if (locale === "zh-HK") return zh_hk2_team_settings(inputs)
	if (locale === "ur") return ur_team_settings(inputs)
	if (locale === "fa") return fa_team_settings(inputs)
	if (locale === "sw") return sw_team_settings(inputs)
	if (locale === "nl") return nl_team_settings(inputs)
	return en_team_settings(inputs)
});